import React from 'react';

/**
 * StatCard & StatSkeleton
 * Reusable card components designed for responsive metrics grids.
 * Recommended grid usage in consumer pages: grid-cols-1 xs:grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4
 */
export const StatCard = ({ label, value, sub, icon: Icon, color = 'slate', onClick, className = '' }) => {
  const colorMap = {
    slate:   'bg-slate-100 text-slate-700',
    emerald: 'bg-emerald-100 text-emerald-700',
    amber:   'bg-amber-100 text-amber-700',
    blue:    'bg-blue-100 text-blue-700',
    red:     'bg-red-100 text-red-700',
    indigo:  'bg-indigo-100 text-indigo-700',
  };

  return (
    <div
      onClick={onClick}
      className={`bg-white rounded-xl border border-slate-200/80 p-4 sm:p-5 shadow-xs flex items-start gap-3 sm:gap-4 transition-all duration-200 ${
        onClick ? 'cursor-pointer hover:shadow-md hover:-translate-y-0.5' : ''
      } ${className}`}
    >
      {Icon && (
        <div className={`w-10 h-10 sm:w-11 sm:h-11 rounded-xl flex items-center justify-center shrink-0 ${colorMap[color] || colorMap.slate}`}>
          <Icon size={20} />
        </div>
      )}
      <div className="min-w-0 flex-1">
        <p className="text-slate-500 text-xs sm:text-sm font-medium truncate">{label}</p>
        <p className="text-xl sm:text-2xl font-extrabold text-slate-900 mt-1 leading-none truncate">{value}</p>
        {sub && <p className="text-slate-400 text-[11px] sm:text-xs mt-1.5 truncate">{sub}</p>}
      </div>
    </div>
  );
};

export const StatSkeleton = () => (
  <div className="bg-white rounded-xl border border-slate-200/80 p-4 sm:p-5 shadow-xs flex items-start gap-3 sm:gap-4">
    <div className="w-10 h-10 sm:w-11 sm:h-11 rounded-xl bg-slate-100 animate-pulse shrink-0" />
    <div className="flex-1 space-y-2 py-0.5">
      <div className="h-3 w-24 bg-slate-100 rounded animate-pulse" />
      <div className="h-6 w-20 bg-slate-100 rounded animate-pulse" />
      <div className="h-2.5 w-32 bg-slate-100 rounded animate-pulse" />
    </div>
  </div>
);
